import restClient, { headerKey } from './restClient';
import { environment } from '../environments/environment';

const LANNISTERS_URL = `${environment.REACT_APP_BASE_URL}/lannisters/`;
const agoraService = {

  getTeleSession: (sessionID: string) => {
    return restClient.makePostRequest(`${LANNISTERS_URL}teleconsult/sessions/${sessionID || '571'}/join/`, {}, {
      headers: {
        [headerKey.AuthToken]: restClient.getHeader(headerKey.AccessToken),
      },
    });
  },
};

export default agoraService;